<template>
  <div class="sidebar pa-4">
    <v-tabs v-model="tabs" :show-arrows="false">
      <v-tab class="text-none">Navigasi</v-tab>
      <v-tab class="text-none">Riwayat Kunjungan</v-tab>
    </v-tabs>
    <v-tabs-items v-model="tabs">
      <v-tab-item>
        <v-list dense>
          <div v-for="(section, i) in assesmentSection" :key="i">
            <v-subheader v-if="section.group !== ''">{{
              section.group
            }}</v-subheader>
            <v-list-item
              v-for="(item, j) in section.items"
              :key="j"
              link
              class="d-flex align-center"
            >
              <v-list-item-content
                @click="navigateTo(item.key)"
                class="list-item"
              >
                <v-list-item-title>{{ item.section }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </div>
        </v-list>
      </v-tab-item>
      <v-tab-item>
        <history-visit-tab :header-data="headerData" />
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import HistoryVisitTab from './HistoryVisitTab.vue';
import moment from 'moment-timezone';

import Constant from '@/const';
const axios = require('axios');

export default {
  name: 'HistorySidebar',
  components: {
    HistoryVisitTab,
  },
  props: {
    headerData: {
      type: Array,
      default: null,
    },
    unit: {
      type: String,
      default: '',
    },
  },
  computed: {
    isLargeDisplay() {
      return this.$vuetify.breakpoint.name === 'xl';
    },
    isAdult() {
      const birthDate = moment(
        this.$store.getters.selectedPatient.meta.birthDate,
        'DD MMMM YYYY',
      );
      const diff = moment().diff(birthDate, 'month');
      return diff > 228;
    },
  },
  data() {
    return {
      tabs: null,
      mini: false,
      drawer: true,
      isLoading: false,
      data: [],
      removeKeyDental: ['physical', 'anatomical-mark', 'assessment-planning'],
      removeKeyGeneral: ['odontogram', 'assessment-planning'], // UMUM
      removeKeyGeneralAss: ['odontogram', 'assessment', 'planning'], // Asesmen General
      assesmentSection: [
        {
          group: 'Asesmen Perawat',
          items: [
            {
              section: 'Data Subjektif',
              key: 'subjective',
            },
            {
              section: 'Data Objektif',
              key: 'objective-nurse',
            },
            {
              section: 'Skrining Gizi',
              key: 'nutrition-screening',
            },
            {
              section: 'Asesmen Risiko Jatuh',
              key: 'fall-risk',
            },
            {
              section: 'Asesmen Nyeri',
              key: 'pain-assessment',
            },
          ],
        },
        {
          group: 'Asesmen Dokter',
          items: [
            {
              section: 'Data Subjektif',
              key: 'subjective-doctor',
            },
            {
              section: 'Data Objektif',
              key: 'objective-doctor',
            },
            {
              section: 'Odontogram',
              key: 'odontogram',
            },
            {
              section: 'Pemeriksaan Fisik',
              key: 'physical',
            },
            {
              section: 'Penanda Anatomi Tubuh',
              key: 'anatomical-mark',
            },
            {
              section: 'Asesmen',
              key: 'assessment',
            },
            {
              section: 'Hasil Penunjang Lainnya',
              key: 'other-support',
            },
            {
              section: 'Planning',
              key: 'planning',
            },
            {
              section: 'Asesmen & Planning',
              key: 'assessment-planning',
            },
          ],
        },
      ],
    };
  },
  mounted() {
    this.showAllHistories();
    this.handleAssesmentSectionByUnit();
  },
  methods: {
    handleAssesmentSectionByUnit() {
      let remove = [];
      switch (this.unit) {
        case 'Poli Gigi':
          remove = this.removeKeyDental;
          break;
        case 'Poli Fisioterapi':
          remove = this.removeKeyGeneralAss;
          break;
        default:
          remove = this.removeKeyGeneral;
      }

      this.assesmentSection[1].items = this.assesmentSection[1].items.filter(
        v => !remove.includes(v.key),
      );

      if (this.unit === 'Poli Fisioterapi') {
        this.assesmentSection = [this.assesmentSection[1]];
        this.assesmentSection[0].group = '';
      }
    },
    navigateTo(item) {
      this.$emit('navigate-to', item);
    },
    async showAllHistories() {
      this.isLoading = true;
      try {
        const response = await axios.get(
          Constant.apiUrl.concat(
            `/patient/emr/${this.$store.getters.selectedPatient.id_emr}`,
          ),
        );
        const datas = response.data.data.checkup
          .filter(data => {
            if (data.unit[0].name.toLowerCase() !== 'poli fisioterapi') {
              return (
                data.timestamps?.doctor_created_at &&
                data.timestamps.doctor_created_at.length > 0
              );
            } else {
              return (
                (data.timestamps?.doctor_created_at &&
                  data.timestamps.doctor_created_at.length > 0) ||
                (data.timestamps?.nurse_created_at &&
                  data.timestamps.nurse_created_at.length > 0)
              );
            }
          })
          .sort((a, b) => {
            const moment1 = moment(b.timestamps.doctor_created_at);
            const moment2 = moment(a.timestamps.doctor_created_at);
            return moment1.diff(moment2);
          });
        this.data = datas.map((item, index) => {
          const isGeneral =
            item.unit[0].name.toLowerCase() === 'poli fisioterapi';
          return {
            index,
            poly: item.unit[0].name.toUpperCase(),
            date: moment(item.timestamps.doctor_created_at).format(
              'DD MMMM YYYY',
            ),
            time: moment(item.timestamps.doctor_created_at).format('HH:mm'),
            diagnoses: !isGeneral
              ? [item.assesment?.main_diagnose?.diagnose?.description].concat(
                  item.assesment?.other_diagnose?.map(
                    diagnose => diagnose.diagnose.description,
                  ),
                )
              : item.assesment?.diagnoses,
            therapies: item.alldrugs.map(drug => {
              return {
                label: drug.drugs
                  ? `Racik (${drug.usage}, ${drug.quantity} ${drug.packaging})`
                  : 'Non Racik',
                drug: drug.drugs
                  ? drug.drugs
                      .map(mix => {
                        return `${mix.name} ${mix.dosage} ${mix.unit_dosage} ${mix.preparation}`;
                      })
                      .join(', ')
                  : `${drug.name} ${drug.dosage} ${drug.unit_dosage} ${drug.preparation}, ${drug.usage}, ${drug.quantity} ${drug.preparation}`,
              };
            }),
            doctor: item.timestamps?.doctor_by[0]?.detail[0]?.name,
            nurse: item.timestamps?.nurse_by[0]?.detail[0]?.name,
            nutritionScreening: this.nutritionScreeningResult(
              item?.nutrition_screening || null,
            ),
            fallRisk: this.fallRiskResult(item?.assesment?.fallRisk || null),
            imt: this.imtChipDecision(item?.nutrition_category || ''),
            isGeneral: isGeneral,
          };
        });
      } catch (error) {
        this.data = [];
      } finally {
        this.isLoading = false;
      }
    },
    fallRiskResult(data) {
      if (!data) return null;
      let result, score;
      if (this.isAdult) {
        score =
          (data.fallHistory?.score || 0) +
          (data.howToWalk?.score || 0) +
          (data.mentalStatus?.score || 0) +
          (data.secondaryDiagnosis?.score || 0) +
          (data.useHeparinLockTherapy?.score || 0) +
          (data.walkTool?.score || 0);
        if (isNaN(score)) {
          result = null;
        }
        if (score <= 24) {
          result = {
            text: 'Tidak Berisiko Jatuh',
            color: 'green',
          };
        }
        if (score > 24 && score <= 50) {
          result = {
            text: 'Risiko Jatuh Rendah',
            color: 'yellow',
          };
        }
        if (score > 50) {
          result = {
            text: 'Risiko Jatuh Tinggi',
            color: 'red',
          };
        }
      } else {
        score =
          (data.ageScore || 0) +
          (data.cognitiveImpairment?.score || 0) +
          (data.diagnosis?.score || 0) +
          (data.medicinalUse?.score || 0) +
          (data.surgery?.score || 0) +
          (data.genderScore || 0);
        if (isNaN(score)) {
          result = null;
        }
        if (score < 7) {
          result = {
            text: 'Tidak Berisiko Jatuh',
            color: 'green',
          };
        }
        if (score >= 7 && score <= 11) {
          result = {
            text: 'Risiko Jatuh Rendah',
            color: 'yellow',
          };
        }
        if (score > 11) {
          result = {
            text: 'Risiko Jatuh Tinggi',
            color: 'red',
          };
        }
      }
      return result;
    },
    nutritionScreeningResult(data) {
      if (!data) return null;
      let result, score;
      if (this.isAdult) {
        score =
          (data.isFoodIntakePoorDueToDecreasedAppetite?.score || 0) +
          (data.isHaveSeriousIllness?.score || 0) +
          (data.isUnplannedWeightLoss?.score || 0);

        if (isNaN(score)) {
          result = null;
        }
        if (score <= 1) {
          result = {
            text: 'Tidak Berisiko Malnutrisi',
            color: 'green',
            score,
          };
        }
        if (score === 2) {
          result = {
            text: 'Risiko Malnutrisi',
            color: 'yellow',
            score,
          };
        }
        if (score >= 3) {
          result = {
            text: 'Malnutrisi',
            color: 'red',
            score,
          };
        }
      } else {
        score =
          (data.isThereCausesMalnourished?.score || 0) +
          (data.isThereOfTheseCondition?.score || 0) +
          (data.isThin?.score || 0) +
          (data.isWeightLossLastMonth?.score || 0);

        if (isNaN(score)) {
          result = null;
        }
        if (score === 0) {
          result = {
            text: 'Berisiko Rendah',
            color: 'green',
          };
        }
        if (score >= 1 && score <= 3) {
          result = {
            text: 'Berisiko Sedang',
            color: 'yellow',
          };
        }
        if (score >= 4 && score <= 5) {
          result = {
            text: 'Berisiko Tinggi',
            color: 'red',
          };
        }
      }
      return result;
    },
    imtChipDecision(text) {
      if (!text) return null;
      let result;
      switch (text.toLowerCase()) {
        case 'gizi buruk':
        case 'underweight':
        case 'obesitas':
        case 'obesity':
          result = {
            text,
            color: 'red',
          };
          break;
        case 'gizi kurang':
        case 'gizi lebih':
        case 'overweight':
          result = {
            text,
            color: 'yellow',
          };
          break;
        case 'gizi baik':
        case 'normal':
          result = {
            text,
            color: 'green',
          };
          break;
        case 'berisiko gizi lebih':
          result = {
            text,
            color: 'light-yellow',
          };
          break;
      }
      return result;
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep .v-slide-group__content.v-tabs-bar__content {
  background-color: #fafafa !important;
}

.sidebar {
  height: 100%;
  background-color: #fafafa !important;

  .v-tabs,
  .v-tabs-items,
  .v-list,
  .v-list-item,
  .v-tab,
  .v-tab-item {
    background-color: transparent !important;
  }
  overflow-y: auto;
  ::-webkit-scrollbar {
    width: 3px;
    background-color: #c2c2c2;
  }
  ::-webkit-scrollbar-thumb {
    width: 3px;
    background-color: black;
  }

  // #{&}-title {
  //   margin-right: 6rem;
  //   padding-left: 0.8rem;
  // }
  #{&}-history {
    display: block;
  }
}

.list-item {
  line-height: 1.1;
  text-align: start !important;
}

@media (max-width: 1366px) {
  .v-tabs .v-tab {
    font-size: 13px;
    padding-left: 8px;
    padding-right: 8px;
  }
}
</style>
